// extracted by mini-css-extract-plugin
export var active = "_fn-7";
export var blink = "_fn-8";
export var dropDownSelector = "_fn-4";
export var dropDownWrapper = "_fn-3";
export var fakeCursor = "_fn-6";
export var fontSizeButton = "_fn-9";
export var formQuillEditor = "_fn-0";
export var pressed = "_fn-a";
export var qlBlank = "_fn-1";
export var textFormattingToolbar = "_fn-2";
export var textToolbarOption = "_fn-5";